// This file is auto-generated by @hey-api/openapi-ts

import type { GetApiAdminBusinessesResponse, GetApiAdminRatingsResponse, GetApiAdminBusinessesByIdResponse, PostApiAttachmentsRatingByRatingIdResponse, GetApiBusinessesResponse, PostApiBusinessesResponse, GetApiBusinessesByIdResponse, GetApiBusinessesByIdRatingsResponse, GetApiEmployeesMineResponse, GetApiEmployeesOfBusinessByBusinessIdResponse, GetApiOnboardingDocumentsResponse, GetApiRatingsResponse, GetApiRatingsCustomerByCustomerNameResponse, GetWeatherForecastResponse } from './types.gen';

const adminBusinessDtoSchemaResponseTransformer = (data: any) => {
    if (data.created) {
        data.created = new Date(data.created);
    }
    return data;
};

export const getApiAdminBusinessesResponseTransformer = async (data: any): Promise<GetApiAdminBusinessesResponse> => {
    data = data.map((item: any) => {
        return adminBusinessDtoSchemaResponseTransformer(item);
    });
    return data;
};

const adminRatingDtoSchemaResponseTransformer = (data: any) => {
    if (data.created) {
        data.created = new Date(data.created);
    }
    return data;
};

export const getApiAdminRatingsResponseTransformer = async (data: any): Promise<GetApiAdminRatingsResponse> => {
    data = data.map((item: any) => {
        return adminRatingDtoSchemaResponseTransformer(item);
    });
    return data;
};

const adminBusinessDocumentDtoSchemaResponseTransformer = (data: any) => {
    if (data.uploadedAt) {
        data.uploadedAt = new Date(data.uploadedAt);
    }
    return data;
};

const adminBusinessDetailDtoSchemaResponseTransformer = (data: any) => {
    if (data.created) {
        data.created = new Date(data.created);
    }
    if (data.updated) {
        data.updated = new Date(data.updated);
    }
    if (data.avvAcceptedAt) {
        data.avvAcceptedAt = new Date(data.avvAcceptedAt);
    }
    if (data.documents) {
        data.documents = data.documents.map((item: any) => {
            return adminBusinessDocumentDtoSchemaResponseTransformer(item);
        });
    }
    if (data.otherBusinessesByOwner) {
        data.otherBusinessesByOwner = data.otherBusinessesByOwner.map((item: any) => {
            return adminBusinessDtoSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getApiAdminBusinessesByIdResponseTransformer = async (data: any): Promise<GetApiAdminBusinessesByIdResponse> => {
    data = adminBusinessDetailDtoSchemaResponseTransformer(data);
    return data;
};

const businessUserSchemaResponseTransformer = (data: any) => {
    if (data.business) {
        data.business = businessSchemaResponseTransformer(data.business);
    }
    if (data.created) {
        data.created = new Date(data.created);
    }
    if (data.updated) {
        data.updated = new Date(data.updated);
    }
    return data;
};

const businessSchemaResponseTransformer = (data: any) => {
    if (data.avvAcceptedAt) {
        data.avvAcceptedAt = new Date(data.avvAcceptedAt);
    }
    if (data.freeTrialEndsAt) {
        data.freeTrialEndsAt = new Date(data.freeTrialEndsAt);
    }
    if (data.created) {
        data.created = new Date(data.created);
    }
    if (data.updated) {
        data.updated = new Date(data.updated);
    }
    if (data.businessUsers) {
        data.businessUsers = data.businessUsers.map((item: any) => {
            return businessUserSchemaResponseTransformer(item);
        });
    }
    if (data.ratings) {
        data.ratings = data.ratings.map((item: any) => {
            return customerRatingSchemaResponseTransformer(item);
        });
    }
    return data;
};

const businessCustomerSchemaResponseTransformer = (data: any) => {
    if (data.business) {
        data.business = businessSchemaResponseTransformer(data.business);
    }
    if (data.created) {
        data.created = new Date(data.created);
    }
    if (data.updated) {
        data.updated = new Date(data.updated);
    }
    return data;
};

const customerRatingSchemaResponseTransformer = (data: any) => {
    if (data.created) {
        data.created = new Date(data.created);
    }
    if (data.createdByBusiness) {
        data.createdByBusiness = businessSchemaResponseTransformer(data.createdByBusiness);
    }
    if (data.businessCustomer) {
        data.businessCustomer = businessCustomerSchemaResponseTransformer(data.businessCustomer);
    }
    if (data.attachments) {
        data.attachments = data.attachments.map((item: any) => {
            return attachmentSchemaResponseTransformer(item);
        });
    }
    if (data.updated) {
        data.updated = new Date(data.updated);
    }
    return data;
};

const attachmentSchemaResponseTransformer = (data: any) => {
    if (data.customerRating) {
        data.customerRating = customerRatingSchemaResponseTransformer(data.customerRating);
    }
    if (data.size) {
        data.size = BigInt(data.size.toString());
    }
    if (data.created) {
        data.created = new Date(data.created);
    }
    return data;
};

export const postApiAttachmentsRatingByRatingIdResponseTransformer = async (data: any): Promise<PostApiAttachmentsRatingByRatingIdResponse> => {
    data = attachmentSchemaResponseTransformer(data);
    return data;
};

const businessDtoSchemaResponseTransformer = (data: any) => {
    if (data.created_at) {
        data.created_at = new Date(data.created_at);
    }
    if (data.avvAcceptedAt) {
        data.avvAcceptedAt = new Date(data.avvAcceptedAt);
    }
    return data;
};

export const getApiBusinessesResponseTransformer = async (data: any): Promise<GetApiBusinessesResponse> => {
    data = data.map((item: any) => {
        return businessDtoSchemaResponseTransformer(item);
    });
    return data;
};

export const postApiBusinessesResponseTransformer = async (data: any): Promise<PostApiBusinessesResponse> => {
    data = businessDtoSchemaResponseTransformer(data);
    return data;
};

export const getApiBusinessesByIdResponseTransformer = async (data: any): Promise<GetApiBusinessesByIdResponse> => {
    data = businessDtoSchemaResponseTransformer(data);
    return data;
};

const businessRatingItemDtoSchemaResponseTransformer = (data: any) => {
    if (data.created_at) {
        data.created_at = new Date(data.created_at);
    }
    return data;
};

export const getApiBusinessesByIdRatingsResponseTransformer = async (data: any): Promise<GetApiBusinessesByIdRatingsResponse> => {
    data = data.map((item: any) => {
        return businessRatingItemDtoSchemaResponseTransformer(item);
    });
    return data;
};

const employmentDtoSchemaResponseTransformer = (data: any) => {
    if (data.created) {
        data.created = new Date(data.created);
    }
    if (data.modified) {
        data.modified = new Date(data.modified);
    }
    return data;
};

export const getApiEmployeesMineResponseTransformer = async (data: any): Promise<GetApiEmployeesMineResponse> => {
    data = data.map((item: any) => {
        return employmentDtoSchemaResponseTransformer(item);
    });
    return data;
};

export const getApiEmployeesOfBusinessByBusinessIdResponseTransformer = async (data: any): Promise<GetApiEmployeesOfBusinessByBusinessIdResponse> => {
    data = data.map((item: any) => {
        return employmentDtoSchemaResponseTransformer(item);
    });
    return data;
};

const documentDtoSchemaResponseTransformer = (data: any) => {
    if (data.uploadedAt) {
        data.uploadedAt = new Date(data.uploadedAt);
    }
    return data;
};

export const getApiOnboardingDocumentsResponseTransformer = async (data: any): Promise<GetApiOnboardingDocumentsResponse> => {
    data = data.map((item: any) => {
        return documentDtoSchemaResponseTransformer(item);
    });
    return data;
};

const ratingListItemDtoSchemaResponseTransformer = (data: any) => {
    if (data.created_at) {
        data.created_at = new Date(data.created_at);
    }
    return data;
};

export const getApiRatingsResponseTransformer = async (data: any): Promise<GetApiRatingsResponse> => {
    data = data.map((item: any) => {
        return ratingListItemDtoSchemaResponseTransformer(item);
    });
    return data;
};

const ratingByCustomerDtoSchemaResponseTransformer = (data: any) => {
    if (data.created_at) {
        data.created_at = new Date(data.created_at);
    }
    return data;
};

export const getApiRatingsCustomerByCustomerNameResponseTransformer = async (data: any): Promise<GetApiRatingsCustomerByCustomerNameResponse> => {
    data = data.map((item: any) => {
        return ratingByCustomerDtoSchemaResponseTransformer(item);
    });
    return data;
};

const weatherForecastSchemaResponseTransformer = (data: any) => {
    if (data.date) {
        data.date = new Date(data.date);
    }
    return data;
};

export const getWeatherForecastResponseTransformer = async (data: any): Promise<GetWeatherForecastResponse> => {
    data = data.map((item: any) => {
        return weatherForecastSchemaResponseTransformer(item);
    });
    return data;
};